export const quotesArr = [
  "Life isn’t about getting and having, it’s about giving and being.",
  "Whatever the mind of man can conceive and believe, it can achieve.",
  "Strive not to be a success, but rather to be of value.",
  "I attribute my success to this: I never gave or took any excuse.",
  "You miss 100% of the shots you don’t take.",
  "Every strike brings me closer to the next home run.",
  "Definiteness of purpose is the starting point of all achievement.",
  "We must balance conspicuous consumption with conscious capitalism.",
  "Life is what happens to you while you’re busy making other plans.",
  "We become what we think about.",
  "An unexamined life is not worth living.",
  "Eighty percent of success is showing up.",
  "Your time is limited, so don’t waste it living someone else’s life.",
  "Winning isn’t everything, but wanting to win is.",
  "I am not a product of my circumstances. I am a product of my decisions.",
  "Either you run the day, or the day runs you.",
  "Whether you think you can or you think you can’t, you’re right.",
  "The best revenge is massive success.",
  "Life shrinks or expands in proportion to one’s courage.",
  "The only person you are destined to become is the person you decide to be.",
  "Believe you can and you’re halfway there.",
  "Everything you’ve ever wanted is on the other side of fear.",
  "Teach thy tongue to say, “I do not know,” and thous shalt progress.",
  "Start where you are. Use what you have. Do what you can.",
  "Fall seven times and stand up eight.",
  "Everything has beauty, but not everyone can see.",
  "When I let go of what I am, I become what I might be.",
  "Happiness is not something readymade. It comes from your own actions.",
  "If you’re offered a seat on a rocket ship, don’t ask what seat! Just get on.",
  "If the wind will not serve, take to the oars.",
  "Too many of us are not living our dreams because we are living our fears.",
  "If you want to lift yourself up, lift up someone else.",
  "I didn’t fail the test. I just found 100 ways to do it wrong.",
  "A person who never made a mistake never tried anything new.",
  "There are no traffic jams along the extra mile.",
  "It is never too late to be what you might have been.",
  "You become what you believe.",
  "I would rather die of passion than of boredom.",
  "Build your own dreams, or someone else will hire you to build theirs.",
  "Education costs money. But then so does ignorance.",
  "It does not matter how slowly you go as long as you do not stop.",
  "You can’t use up creativity. The more you use, the more you have.",
  "Dream big and dare to fail.",
  "Our lives begin to end the day we become silent about things that matter.",
  "Do what you can, where you are, with what you have.",
  "If you do what you’ve always done, you’ll get what you’ve always gotten.",
  "Dreaming, after all, is a form of planning.",
  "You may be disappointed if you fail, but you are doomed if you don’t try.",
  "Remember no one can make you feel inferior without your consent.",
  "Life is what we make it, always has been, always will be.",
  "Change your thoughts and you change your world.",
  "Either write something worth reading or do something worth writing.",
  "The only way to do great work is to love what you do.",
  "If you can dream it, you can achieve it."
];
